export default __webpack_public_path__ + "static/media/ideas_2.0686b7ed.PNG";